let globalShowAlert: (content: {
	title?: string;
	description: string;
}) => void = () => {};

export function setGlobalShowAlert(
	fn: (content: { title?: string; description: string }) => void
) {
	globalShowAlert = fn;
}

export function callGlobalShowAlert(content: {
	title?: string;
	description: string;
}) {
	if (globalShowAlert) {
		globalShowAlert(content);
	}
}
